<template lang="pug">
.guide
  .guide-kv
    .guide-kv-image
      img.guide-kv-img(src="/static/images/manual/guide_kv.webp")
    h2.guide-kv-text 市況分析
  .guide-breadcrumb
    .guide-breadcrumb-child
      p.guide-breadcrumb-child-current
  .guide-functionList(v-for="item in article")
    .guide-headLineWrap
      h3.guide-headLineWrap-headLine {{ item.titleOverviewParent }}
    ul.guide-articleGroup
      li.guide-articleList(v-for="itemArticleLink in item.list")
        a.guide-articleLinkOuter(:href="itemArticleLink.link")
          .guide-articleLinkInner
            .guide-articleLinkInner-textArea
              h4.guide-articleLinkInner-textArea-title {{ itemArticleLink.titleList }}
              p.guide-articleLinkInner-textArea-text {{ itemArticleLink.textList }}
            .guide-articleLinkInner-arrowImage
</template>

<script>
export default {
  data () {
    return {
      guide: '',
      job_notification_settings: '',
      article: [
          {
            titleOverviewParent: '基本的な操作方法',
            list: [
              {
                link: '/guide/market_analysis/1-a',
                titleList: '市況分析機能の概要',
                textList: 'システム内の求人情報を集計できる機能です。',
              },
              {
                link: '/guide/market_analysis/1-b',
                titleList: '集計の目的と集計対象を決める',
                textList: '市況分析では、様々なパターンで集計できるが故に、まずは集計目的を決める必要があります。',
              },
              {
                link: '/guide/market_analysis/1-c',
                titleList: '集計に使う求人を指定する',
                textList: '集計目的と集計対象が確定したら、どういったセグメントを集計するのかを明確にしましょう。',
              },
              {
                link: '/guide/market_analysis/1-d',
                titleList: '集計した条件を保存する',
                textList: '集計した内容を今後も確認する可能性がある場合には、条件選択部分の最下部にある「条件を保存」をクリックして、条件保存を行うことが可能です。',
              },
              {
                link: '/guide/market_analysis/1-e',
                titleList: '集計した値をDLする',
                textList: '集計したデータを使って資料作成や更なる分析を進めたい場合には、集計数値のまとまった表の下部にある「CSVダウンロード」をクリックしてください。「すべての項目を含める」部分にチェックを入れると、画面上には表示されていないセグメントの数値も含めて。集計結果をCSVでダウンロードすることが可能です。',
              },
            ],
          },
          {
            titleOverviewParent: '商圏の求人動向分析',
            list: [
              {
                link: '/guide/market_analysis/2-a',
                titleList: '活用のイメージ',
                textList: 'スタンダードな活用事例の1つとして、自社商圏の分析に使うケースをご紹介します。この活用事例では、例えば、自社商圏において、自社が出稿している求人が商圏のどの程度の割合を占めているのか、提示している時給は他社の求人と遜色ない水準なのかを把握することができます。',
              },
              {
                link: '/guide/market_analysis/2-b',
                titleList: 'ターゲット領域を決める',
                textList: '集計する数値をより具体的にするために、事前に目的とターゲット領域を明確にしておく必要があります。例えば、自社商圏の中で、求人数が増えており、自社で現在カバーしていない職種を把握したい、という場合には、「集計縦軸：職種」、「エリアの項目(勤務地など)：自社商圏のエリア」を設定する必要があります。',
              },
              {
                link: '/guide/market_analysis/2-c',
                titleList: '集計から省きたい企業を登録する',
                textList: '市況分析機能には、「除外企業管理」の機能も適用することができるため、特定の企業の求人を集計対象から省くことも可能です。',
              },
              {
                link: '/guide/market_analysis/2-d',
                titleList: '集計に使う条件を指定して条件を保存する',
                textList: '各種条件を設定して実際に集計が完了したら、集計条件を保存しておくことをお勧めします。',
              },
            ],
          },
          {
            titleOverviewParent: '特定企業の分析',
            list: [
              {
                link: '/guide/market_analysis/3-a',
                titleList: '活用のイメージ',
                textList: '応用編の活用事例の1つとして、特定企業の分析に使うケースをご紹介します。',
              },
              {
                link: '/guide/market_analysis/3-b',
                titleList: 'ターゲットを明確にする',
                textList: '集計する数値をより具体的にするために、事前に目的とターゲット領域を明確にしておく必要があります。',
              },
              {
                link: '/guide/market_analysis/3-c',
                titleList: '集計したい企業を登録する',
                textList: '市況分析機能には、「登録企業管理」の機能も適用することができるため、特定の企業の求人に限定して集計を行うことも可能です。',
              },
              {
                link: '/guide/market_analysis/3-d',
                titleList: '集計から省きたい企業を登録する',
                textList: '市況分析機能には、「除外企業管理」の機能も適用することができるため、特定の企業の求人を集計対象から省くことも可能です。',
              },
              {
                link: '/guide/market_analysis/3-e',
                titleList: '集計に使う条件を指定して条件を保存する',
                textList: '各種条件を設定して実際に集計が完了したら、集計条件を保存しておくことをお勧めします。',
              },
            ],
          },
        ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/guide/market-analysis/MarketAnalysis.vue